(function(){
    'use strict';
    angular.module('app').controller('AreaController', AreaController);

    AreaController.$inject = ['$scope'];

    function AreaController($scope) {
        let vm = this;
        vm.mapControls = [
            { control: viewJobLists, position: 'BOTTOM_CENTER' }
        ];
        vm.viewTaskLocation = viewTaskLocation;

        function viewJobLists(controlDiv, map) {
            let controlUI = document.createElement('div');
                controlUI.style.backgroundColor = '#FFF';
                controlUI.style.borderRadius = '3px';
                controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
                controlUI.style.cursor = 'pointer';
                controlUI.style.marginBottom = '10px';
                controlUI.style.textAlign = 'center';
                controlUI.title = 'Click to view job lists';
                controlDiv.appendChild(controlUI);

            let controlText = document.createElement('div');
                controlText.style.color = '#747474';
                controlText.style.fontFamily = 'Open Sans, Helvetica Neue, Helvetica, sans-serif';
                controlText.style.fontSize = '14px';
                controlText.style.lineHeight = '34px';
                controlText.style.paddingLeft = '20px';
                controlText.style.paddingRight = '20px';
                controlText.style.fontWeight = 'bold';
                controlText.innerHTML = 'VIEW JOB LISTS';
                controlUI.appendChild(controlText);
            
            controlUI.addEventListener('click', function() {
                // Add logic here
                console.log('working fine');
            }); 
        }

        function viewTaskLocation(data){
            vm.officeLocation = data.position;
            vm.zoom = 20;
        }

        //TEST DATA ONLY
        vm.locations = [
            {
                position: new google.maps.LatLng(-33.91721, 151.22630),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91539, 151.22820),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91747, 151.22912),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91910, 151.22907),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91725, 151.23011),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91872, 151.23089),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91784, 151.23094),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91682, 151.23149),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91790, 151.23463),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91666, 151.23468),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.916988, 151.233640),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91662347903106, 151.22879464019775),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.916365282092855, 151.22937399734496),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91665018901448, 151.2282474695587),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.919543720969806, 151.23112279762267),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91608037421864, 151.23288232673644),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91851096391805, 151.2344058214569),
                type: 'package'
            }, 
            {
                position: new google.maps.LatLng(-33.91818154739766, 151.2346203981781),
                type: 'package'
              
            }, 
            {
                position: new google.maps.LatLng(-33.91727341958453, 151.23348314155578),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-31.563910, 147.154312),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-33.718234, 150.363181),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-33.727111, 150.371124),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-33.848588, 151.209834),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-33.851702, 151.216968),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-34.671264, 150.863657),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-34.671264, 150.863657),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-35.304724, 148.662905),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-36.817685, 175.699196),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-36.828611, 175.790222),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.750000, 145.116667),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.759859, 145.128708),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.765015, 145.133858),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.770104, 145.143299),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.773700, 145.145187),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.774785, 145.137978),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-37.819616, 144.968119),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-38.330766, 144.695692),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-39.927193, 175.053218),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-41.330162, 174.865694),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-42.734358, 147.439506),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-42.734358, 147.501315),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-42.735258, 147.438000),
                type: 'package'
            },
            {
                position: new google.maps.LatLng(-43.999792, 170.463352),
                type: 'package'
            }
        ]
        vm.officeLocation = {lat:-33.91722, lng:151.23064};

        vm.listData = [
            {
                header: 'Melborne',
                content: [
                    {
                        id: 1,
                        text: 'Jhon Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: {lat: -33.91721, lng: 151.22630},
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91539, 151.22820),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91747, 151.22912),
                                
                            },                        
                        ]
                    },
                    {
                        id: 2,
                        text: 'Drake Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91910, 151.22907),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91725, 151.23011),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91872, 151.23089),
                                
                            },                        
                        ]
                    },
                    {
                        id: 3,
                        text: 'Mark Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91784, 151.23094),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91682, 151.23149),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91790, 151.23463),
                                
                            },                        
                        ]
                    },
                    {
                        id: 4,
                        text: 'Spencer Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91666, 151.23468),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.916988, 151.233640),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91662347903106, 151.22879464019775),
                                
                            },                        
                        ]
                    },
                ]
            },
            {
                header: 'Sydney',
                content: [
                    {
                        id: 5,
                        text: 'Nevermore Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.916365282092855, 151.22937399734496),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91665018901448, 151.2282474695587),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.919543720969806, 151.23112279762267),
                                
                            },                        
                        ]
                    },
                    {
                        id: 6,
                        text: 'Alicia Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91608037421864, 151.23288232673644),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91851096391805, 151.2344058214569),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91818154739766, 151.2346203981781),
                                
                            },                        
                        ]
                    },
                    {
                        id: 7,
                        text: 'One punce Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.91727341958453, 151.23348314155578),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-31.563910, 147.154312),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.718234, 150.363181),
                                
                            },                        
                        ]
                    },
                    {
                        id: 8,
                        text: 'Samurai Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.727111, 150.371124),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.848588, 151.209834),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-33.851702, 151.216968),
                                
                            },                        
                        ]
                    },
                ]
            },
            {
                header: 'Balarat',
                content: [
                    {
                        id: 9,
                        text: 'Batman Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-34.671264, 150.863657),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-34.671264, 150.863657),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-35.304724, 148.662905),
                                
                            },                        
                        ]
                    },
                    {
                        id: 10,
                        text: 'Super Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-36.817685, 175.699196),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-36.828611, 175.790222),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.750000, 145.116667),
                                
                            },                        
                        ]
                    },
                    {
                        id: 11,
                        text: 'Flash Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.759859, 145.128708),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.765015, 145.133858),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.770104, 145.143299),
                            },                        
                        ]
                    },
                    {
                        id: 12,
                        text: 'Hulk Doe', 
                        subText: 'Task 1 of 3', 
                        fontAwesomeIcon: 'fa fa-map-marker',
                        content: [
                            {
                                text: '21 test address st. Melborne', 
                                subText: 'Jhon dwey', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.773700, 145.145187),
                                
                            },
                            {
                                text: '22 test address st. melborne', 
                                subText: 'Mark doe', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.774785, 145.137978),
                                
                            },
                            {
                                text: '44 route st. Melborne', 
                                subText: 'Pick up', 
                                fontAwesomeIcon: 'fa fa-map-marker',
                                position: new google.maps.LatLng(-37.819616, 144.968119),
                                
                            },                        
                        ]
                    },
                ]
            },
        ]
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/AreaController.js